export default "__VITE_ASSET__Dj_CwX5p__"